































import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator'
import { Customer, emptyCustomer } from '@/services/models'

@Component
export default class EditCustomerModal extends Vue {

  private isModalOpen: boolean = false

  private title: string = ''

  private localCustomer: Customer = emptyCustomer()

  public _commit(value: Customer, buttonEvent: any) {
    // Validate
    console.log('Committed!!', buttonEvent)

    // Really push to event handler
    this.commit(value)
  }

  @Emit()
  public commit(value: Customer) {
    // emit!
  }

  // PUBLIC Interface

  public editCustomer(customer: Customer) {
    this.show()
    this.title = `Edit Customer: ${customer.code}`
    this.localCustomer = { ...customer }      // Copy customer!
  }

  public createNewCustomer() {
    this.show()
    this.isModalOpen = true
    this.title = 'Create new Customer'
    this.localCustomer = emptyCustomer()
  }

  private show() {
    (this.$refs.modalRef as any).show()
  }
}
